export const getWorkflowItemTitle = ({
  locale,
  localeParams,
  customTitle,
  t,
}) => {
  if (customTitle) {
    return customTitle;
  }
  return t(`workflows:${locale}`, localeParams);
};
